/* not reusable had to specify position when active with the user code screen */
import React, { useState } from 'react';

import {
  TextField,
  InputAdornment,
  CircularProgress,
  Button,
} from '@mui/material';

import { ReactComponent as SearchIcon } from '../../../common/assets/icons/search_icon_gray.svg';
import { ReactComponent as SearchIconWhite } from '../../../common/assets/icons/search_icon_white.svg';
import { useAppSelector } from '../../../common/hooks/reduxHooks';
import MobileSubscriptionPopup from '../SubscriptionPopups/MobileSubscriptionPopup';
import NoSubscriptionPopup from '../SubscriptionPopups/NoSubscriptionPopup';

type Props = {
  handleSearch: (text: string) => void;
  isLoading: boolean;
  clinicNotes: boolean;
};

const CodesSearchBar: React.FC<Props> = ({
  handleSearch,
  clinicNotes,
  isLoading = false,
}) => {
  const { user } = useAppSelector((state) => state.model);
  const [searchValue, setSearchValue] = useState('');
  const [noSubscriptionPopup, setNoSubscriptionPopup] = useState(false);
  const [mobileSubscriptionPopup, setMobileSubscriptionPopup] = useState(false);
  const searchRef = React.useRef<HTMLDivElement | null>();

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchValue(event.target.value);
  };

  const handleTappedClear = () => {
    setSearchValue('');
  };

  const onKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (searchValue.length !== 0 && event.code === 'Enter') {
      if (!user) return;
      else if (!user.activeSubscriptionType && !user.organizationId) {
        setNoSubscriptionPopup(true);
        handleTappedClear();
        return;
      } else if (user.activeSubscriptionType === 'mobile') {
        setMobileSubscriptionPopup(true);
        handleTappedClear();
        return;
      }
      triggerSearch();
    }
  };

  const triggerSearch = async () => {
    if (isLoading) return;

    setSearchValue((old) => old.trim());
    handleSearch(searchValue.trim());
    searchRef.current?.blur();
  };

  return (
    <>
      <TextField
        onKeyUp={onKeyUp}
        placeholder='Type description of the procedure'
        size='small'
        color='secondary'
        disabled={isLoading}
        inputRef={(ref) => (searchRef.current = ref)}
        value={searchValue}
        onChange={handleSearchInputChange}
        multiline
        sx={(theme) => ({
          minHeight: '50px',
          width: '100%',
          borderWidth: '2px',
          [`& fieldset`]: {
            borderRadius: '40px',
          },
        })}
        InputProps={{
          style: {
            backgroundColor: 'white',
            minHeight: '50px',
            borderRadius: '40px',
          },
          startAdornment: (
            <InputAdornment sx={{ alignSelf: 'center' }} position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment:
            searchValue.length !== 0 ? (
              <InputAdornment sx={{ alignSelf: 'center' }} position='end'>
                <Button
                  onClick={triggerSearch}
                  color='primary'
                  variant='contained'
                  disableElevation
                  sx={{
                    width: '36px',
                    minWidth: '36px',
                    height: '36px',
                    borderRadius: '36px',
                    padding: '0',
                    background: clinicNotes ? '#0D4E5C' : '#0CBDD4',
                  }}
                >
                  {isLoading ? (
                    <CircularProgress sx={{ color: 'white' }} size='20px' />
                  ) : (
                    <SearchIconWhite style={{ margin: 0, width: '20px' }} />
                  )}
                </Button>
              </InputAdornment>
            ) : undefined,
        }}
      />

      {user && (
        <>
          <MobileSubscriptionPopup
            user={user}
            open={mobileSubscriptionPopup}
            onConfirm={() => setMobileSubscriptionPopup(false)}
            onClose={() => setMobileSubscriptionPopup(false)}
          />
          <NoSubscriptionPopup
            open={noSubscriptionPopup}
            onConfirm={() => setNoSubscriptionPopup(false)}
            onClose={() => setNoSubscriptionPopup(false)}
          />
        </>
      )}
    </>
  );
};

export default CodesSearchBar;
